import React, { useEffect, useState, useRef } from "react";
import "../../_css/AIFeedback.css";
import "../../_css/TeacherManagement.css";
import { formatDateLong, formatGrade } from "../helper/formatters";
import { useDispatch } from "react-redux";
import { downloadReport, getClassReport } from "../../requests";
import { notifyError } from "../helper/Toaster";
import { deleteAuthToken } from "../../utils/helper";
import { useNavigate } from "react-router-dom";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import SearchableDropdown from "../common/SearchableDropdown";

const ReportHistoryUI = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalCount, setTotalCount] = useState(0);

  const [students, setStudents] = useState([]);
  const [name, setName] = useState("");
  const [Myclass, setMyclass] = useState(null);
  const [tests, setTests] = useState([]);

  const [filteredTests, setFilteredTests] = useState(tests);
  const [open, setOpen] = useState(null);

  const handleClick = (grade, subject, exam, file_name) => {
    const url = `/report-history/${encodeURIComponent(
      grade
    )}/${encodeURIComponent(subject)}/${encodeURIComponent(exam)}/${encodeURIComponent(file_name)}`;
    navigate(url);
  };

  const get_students = async (pageVal) => {
    dispatch(startLoader());
    try {
      const res = await getClassReport( {}, {page: pageVal, limit: limit, exam_name: name, grade: Myclass});
      console.log(res.data);

      setTotalCount(res.data.totalCount);
      setTests(res.data.data);
      setFilteredTests(res.data.data);

      // setStudents(res.data.data);
    } catch (error) {
      if (error?.response?.status == 403) {
        notifyError(
          error?.response?.data?.error || "Your session has expired. Please log in again."
        );
        deleteAuthToken();
        navigate("/login");
        return;
      }
      else if (error?.response?.status == 401) {
        notifyError(
          error?.response?.data?.error || "You are not authorized to access this page."
        );
        return;
      } else {
        notifyError("Error fetching students");
      }

      
    } finally {
      dispatch(stopLoader());
    }
  };

  const handleDownloadPDF = async (grade, subject, exam, file_name) => {
    dispatch(startLoader());
    try {
      const res = await downloadReport({ grade, subject, exam, file_name });

      const file = new Blob([res.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${grade}-${subject}-${exam}.pdf`; // 👈 filename
      document.body.appendChild(a);
      a.click();

      // cleanup
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if (error?.response?.status == 403) {
        notifyError(
          error?.response?.data?.error || "Your session has expired. Please log in again."
        );
        deleteAuthToken();
        navigate("/login");
        return;
      } else if (error?.response?.status == 401) {
        notifyError(
          error?.response?.data?.error || "You are not authorized to access this page."
        );
        return;
      } else {
        notifyError("Error downloading report");
      }
    } finally {
      dispatch(stopLoader());
    }
  };

  const handleDownloadExcel = async (grade, subject, exam, file_name) => {
    dispatch(startLoader());
    try {
      const res = await downloadReport({ grade, subject, exam, type: 2, file_name });

      const file = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const url = window.URL.createObjectURL(file);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${grade}-${subject}-${exam}.xlsx`; // 👈 filename
      document.body.appendChild(a);
      a.click();

      // cleanup
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if (error?.response?.status == 403) {
        notifyError(
          error?.response?.data?.error || "Your session has expired. Please log in again."
        );
        deleteAuthToken();
        navigate("/login");
        return;
      } else if (error?.response?.status == 401) {
        notifyError(
          error?.response?.data?.error || "You are not authorized to access this page."
        );
        return;
      } else {
        notifyError("Error downloading excel");
      }
    } finally {
      dispatch(stopLoader());
    }
  };

  const handleDownloadWord = async (grade, subject, exam, file_name) => {
    dispatch(startLoader());
    try {
      const res = await downloadReport({ grade, subject, exam, type: 1, file_name });
      const file = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
      const url = window.URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${grade}-${subject}-${exam}.docx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if (error?.response?.status == 403) {
        notifyError(
          error?.response?.data?.error || "Your session has expired. Please log in again."
        );
        deleteAuthToken();
        navigate("/login");
        return;
      } else if (error?.response?.status == 401) {
        notifyError(
          error?.response?.data?.error || "You are not authorized to access this page."
        );
        return;
      } else {
        notifyError("Error downloading report");
      }
    } finally {
      dispatch(stopLoader());
    }
  };

  const timeoutRef = useRef(null);

  useEffect(() => {
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set a new timeout to call the API after 1.5 seconds
    timeoutRef.current = setTimeout(() => {
      setPage(1);
      get_students(1);
    }, 1500);

    // Cleanup function to clear timeout on unmount or when name/Myclass changes again
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [name, Myclass]);


  useEffect(() => {
    get_students(page);
  }, [page,limit]);


  const numbers = ["All classes", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  return (
    <div className="ai-fd-main" onMouseDown={() => setOpen(null)}>
      <div className="ai-fd-con">
        <div className="ai-fd-head">
          <div className="ai-fd-head-text">Report History</div>
          <div className="ai-fd-right">
            <SearchableDropdown
              options={[...numbers]}
              selected={Myclass}
              setSelected={setMyclass}
              allowManualEntry={false}
              color="#E5E7EB"
              placeHolder="Select class"
            />

            <input
              className="student-list-search"
              placeholder="Search exam"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        </div>
        <div className="ai-fd-table">
          <div className="ai-fd-table-head">
            <div className="ai-fd-head-cell" style={{ width: "18%" }}>
              Test Name
            </div>
            <div className="ai-fd-head-cell" style={{ width: "10%" }}>
              Class
            </div>
            <div className="ai-fd-head-cell" style={{ width: "10%" }}>
              Students
            </div>
            <div className="ai-fd-head-cell" style={{ width: "14%" }}>
              Subject
            </div>

            <div className="ai-fd-head-cell" style={{ width: "14%" }}>
              Status
            </div>
            <div className="ai-fd-head-cell" style={{ width: "20%" }}>
              Date
            </div>

            <div className="ai-fd-head-cell" style={{ width: "14%" }}>
              Actions
            </div>
          </div>
          {filteredTests.length > 0 &&
            filteredTests.map((e, i) => (
              <div key={i} className="ai-fd-table-row">
                <div
                  className="ai-fd-row-cell pe-cursor"
                  style={{ width: "18%" }}
                  onClick={() => handleClick(e.grade, e.subject, e.exam_name)}
                >
                  {e.exam_name}
                </div>
                <div
                  className="ai-fd-row-cell pe-cursor"
                  style={{ width: "10%" }}
                >
                  {formatGrade(e.grade)}
                </div>
                <div className="ai-fd-row-cell" style={{ width: "10%" }}>
                  {" "}
                  {e.total_students}
                </div>
                <div className="ai-fd-row-cell" style={{ width: "14%" }}>
                  {e.subject}
                </div>

                <div className="ai-fd-row-cell" style={{ width: "14%" }}>
                  {"Completed"}
                </div>
                <div
                  className="ai-fd-row-cell"
                  style={{ width: "20%", cursor: "pointer" }}
                >
                  {" "}
                  {formatDateLong(e.last_uploaded)}
                </div>

                <div
                  className="ai-fd-row-cell"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "14%",
                  }}
                >
                  <div className="dropdown" style={{ textAlign: "center" }}>
                    <button
                      onClick={(ev) => {
                        ev.stopPropagation();
                        setOpen(open === i ? null : i);
                      }}
                      className="dropdown-btn"
                    >
                      ⋮
                    </button>

                    {open === i && (
                      <div className="dropdown-content">
                        <div
                          className="option"
                          onMouseDown={() => {
                            handleClick(e.grade, e.subject, e.exam_name, e.file_name);
                            setOpen(null);
                          }}
                        >
                          <img
                            src="/eye-empty.svg"
                            alt="view"
                            style={{
                              width: "16px",
                              height: "16px",
                              marginRight: "8px",
                            }}
                          />
                          View
                        </div>
                        <div
                          className="option"
                          onMouseDown={() => {
                            handleDownloadExcel(
                              e.grade,
                              e.subject,
                              e.exam_name,
                              e.file_name
                            );
                            setOpen(null);
                          }}
                        >
                          Export Excel
                        </div>
                        <div
                          className="option"
                          onMouseDown={() => {
                            handleDownloadPDF(
                              e.grade,
                              e.subject,
                              e.exam_name,
                              e.file_name
                            );
                            setOpen(null);
                          }}
                        >
                          Export PDF
                        </div>
                        <div
                          className="option"
                          onMouseDown={() => {
                            handleDownloadWord(
                              e.grade,
                              e.subject,
                              e.exam_name,
                              e.file_name
                            );
                            setOpen(null);
                          }}
                        >
                          Export Word
                        </div>
                        
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="di-flex" style = {{width: '100%'}}>
          <div style={{ color: "#6B7280" }}>
            {" "}
            Showing {((page-1) * limit )+ 1} to {tests.length + (page - 1) * limit} out of {totalCount}{" "}
            items{" "}
          </div>
          <div
            className="di-flex"
            style={{ justifyContent: "end", gap: "10px" }}
          >
            <button
              disabled={page == 1}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity: page == 1 ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (p > 1 ? p - 1 : p))}
            >
              Previous
            </button>
            <button
              disabled={tests.length + ((page - 1) * limit) >= totalCount}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity:
                  tests.length + ((page - 1) * limit) >= totalCount ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (tests.length ? p + 1 : p))}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportHistoryUI;
